import { render, staticRenderFns } from "./AppHeaderStaffInfo.vue?vue&type=template&id=524749f9&scoped=true&"
import script from "./AppHeaderStaffInfo.vue?vue&type=script&lang=js&"
export * from "./AppHeaderStaffInfo.vue?vue&type=script&lang=js&"
import style0 from "./AppHeaderStaffInfo.vue?vue&type=style&index=0&id=524749f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524749f9",
  null
  
)

export default component.exports